import {Component, HostListener, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {Country, EventItem, Lookups} from "@model";

@Component({
    selector: 'app-live-results',
    templateUrl: './live-results.component.html',
    styleUrls: ['./live-results.component.scss'],
    standalone: false
})

export class LiveResultsComponent extends AbstractComponent implements OnInit {
  @Input() liveEvents: EventItem[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  image: string = '../assets/img/hero2_smaller.webp';
  now: Date = new Date();

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.setResponsiveImage(window.innerWidth);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    if (this.isBrowser) {
      this.setResponsiveImage(event.target.innerWidth);
    }
  }

  private setResponsiveImage(width: number): void {
    this.image = width < 768
      ? '../assets/img/hero2-mobile.webp'
      : '../assets/img/hero2_smaller.webp';
  }
}
